import { useAuth0 } from '@auth0/auth0-react'
import type React from 'react'
import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import img from '../../assets/welcome-image-new.png'
import Footer from '../../components/Footer'
import { persistTrackingParams } from '../../utils/trackingParams'

import penningSymbol from '../../assets/symbol.png'

type LoginScreenProps = {}

const LoginScreen: React.FC<LoginScreenProps> = () => {
  const history = useHistory()
  const location = useLocation()
  const { loginWithRedirect, isAuthenticated } = useAuth0()

  // Persist UTM / gclid / gbraid / wbraid etc. so they survive navigation to /sign-up
  useEffect(() => {
    persistTrackingParams(location.search, location.pathname)
  }, [location.search, location.pathname])

  useEffect(() => {
    if (isAuthenticated) {
      history.push('/app')
    }
  }, [isAuthenticated])

  return (
    <>
      <div className="bg-bg-base flex flex-col md:flex-row min-h-screen text-fg-base font-normal pt-5 relative md:items-center">
        <div className="m-5 space-y-10 md:max-w-lg md:min-w-[400px] shrink-0 md:mx-20 xl:mx-52 transition-all">
          <div className="space-y-4">
            <div className="h-12 w-12 flex items-center justify-center shrink-0 bg-brand-app-menu-hover rounded-full cursor-pointer">
              <img src={penningSymbol} alt="Penning logo" className="h-6" />
            </div>
            <div>
              <p className="text-base font-normal text-fg-subtle">Welcome to</p>
              <p className="text-3xl">Penning Client Dashboard</p>
            </div>
          </div>

          <div className="flex flex-col gap-2 text-base ">
            <button
              className="bg-bg-accent text-white py-3 rounded-md"
              onClick={() => history.push('/sign-up')}
            >
              Get started
            </button>
            <button
              className="bg-bg-component text-fg-base py-3 rounded-md"
              onClick={() => loginWithRedirect()}
            >
              Log in
            </button>
          </div>
        </div>

        <img
          src={img}
          className="h-[500px] md:h-[550px] transition-all max-w-4xl rounded-xl ml-5 w-full object-cover object-left-top border-[#626B6D] border-[1px] border-solid border-r-0 mt-10 md:mt-0"
        />
      </div>
      <Footer />
    </>
  )
}

export default LoginScreen
